<mat-card>
  <div class="container">
    <img src="../../assets/img/404.png">
    <h1 class="mat-display-1 smallmargin">Whoops, that's an error.</h1>
    <a mat-raised-button color="primary" (click)="back()">Go Back</a>
  </div>
</mat-card>
